<template>
    <div id="app">
        <router-view></router-view>
        <DisclaimerFooter />
        <div class="loading-mark" :class="isMarkShow ? 'show' : 'hide'" :style="`display: ${markDisplay};`">
            <div class="loading-box">
                <img src="~assets/img/loading.gif" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { getClientBearer } from "@/utils/authToken";
import DisclaimerFooter from "@/components/footer/DisclaimerFooter.vue";

export default {
    name: "App",
    components: { DisclaimerFooter },
    data() {
        return {
            // 加载蒙版的显隐过度
            markDisplay: "none",
            isMarkShow: false,
        }
    },
    methods: {
        // 获取频道列表
        async getChannels() {
            let res = await this.$get("/category/getall");
            // console.log("频道列表: ", res);
            this.$store.commit("updateChannels", res.data.data);
        },

        async getHotSearch() {
            const res = await this.$get("/search/hot/get");
            this.$store.commit("updateTrendings", res.data.data);
        },

        // 加载蒙版的延迟渲染效果
        show() {
            this.markDisplay = "";
            this.isMarkShow = true;
        },
        hide() {
            this.isMarkShow = false;
            setTimeout(() => {
                this.markDisplay = "none";
            }, 200);
        },

        // 开启实时通信消息服务
        async initIMServer() {
            await this.$store.dispatch("connectWebSocket");
            const connection = JSON.stringify({
                code: 100,
                content: getClientBearer(),
            });
            this.$store.state.ws.send(connection);
        },

        // 关闭websocket
        async closeIMWebSocket() {
            await this.$store.dispatch("closeWebSocket");
        },

        // 获取当前用户的收藏夹列表
        async getFavorites() {
            const user = this.$store.state.user || {};
            const userId = user.userId || user.uid;
            if (!userId) return;
            const res = await this.$get("/productVideo/favorite/folders", {
                params: { userId },
                headers: { Authorization: getClientBearer() }
            });
            if (res.data.code !== 200 || !Array.isArray(res.data.data)) return;
            this.$store.commit("updateFavorites", res.data.data);
        },

    },
    async created() {
        this.$store.commit("syncPlayHistoryFromStorage");
        // 如果缓存中有 token（若依登录写入 teri_token / dj_token），拉取资料并同步 Vuex，应用状态依赖 store.isLogin
        if (localStorage.getItem("teri_token") || localStorage.getItem("dj_token")) {
            await this.$store.dispatch("getPersonalInfo");
        }
        if (localStorage.getItem("teri_token") || localStorage.getItem("dj_token")) {
            await this.initIMServer();
        }
        this.getChannels();
        this.getHotSearch();
    },
    mounted() {
        window.addEventListener('beforeunload', this.closeIMWebSocket);    // beforeunload 事件监听标签页关闭
    },
    async beforeUnmount() {
        await this.closeIMWebSocket();
        window.removeEventListener('beforeunload', this.closeIMWebSocket);
    },
    watch: {
        "$store.state.isLogin"(isLogin) {
            if (isLogin) {
                this.getFavorites();
            } else {
                this.$store.commit("updateFavorites", []);
            }
        },
        "$store.state.isLoading"(current) {
            if (current) {
                this.show();
            } else {
                this.hide();
            }
        }
    }
};
</script>

<style>
html,
body {
    background-color: #f6f7f9;
}

#app {
    margin: 0 auto;
    max-width: 2560px;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f6f7f9;
}

#app > :first-child {
    flex: 1 0 auto;
}

.loading-mark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 50000;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

.loading-box {
    display: flex;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
}

.loading-box img {
    max-height: 33vh;
    max-width: 33vw;
}

.hide {
    animation: fade-out 0.2s ease-out forwards;
}

.show {
    animation: fade-in 0.2s ease-out forwards;
}

/* 淡入动画 */
@keyframes fade-in {
    0% {
        opacity: 0;
        /* 初始状态透明 */
    }

    100% {
        opacity: 1;
        /* 最终状态不透明 */
    }
}

/* 淡出动画 */
@keyframes fade-out {
    0% {
        opacity: 1;
        /* 初始状态不透明 */
    }

    100% {
        opacity: 0;
        /* 最终状态透明 */
    }
}
</style>
